import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Loader from '../common/Loader';
import { Button } from '../../VuexyDesign/atoms/_index';

interface Props {
  onClick: VoidFunction;
  isFetching?: boolean;
}

function LoadMoreButton({ isFetching, onClick }: Props) {
  const { t } = useTranslation('contests');
  if (isFetching) return <Loader />;

  return (
    <Button
      color="primary"
      outline
      onClick={onClick}
      className="px-0 w-100 br-10"
      style={{ paddingLeft: '10px', paddingRight: '10px' }}
    >
      {t('contests:loadMore') as string}
    </Button>
  );
}

export default React.memo(LoadMoreButton);
